import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import { useEffect, useState } from "react";

// Optionally register a font (if you need bold, italic variants etc.)
Font.register({
  family: "Helvetica",
  fonts: [
    { src: "https://fonts.gstatic.com/s/helvetica.woff2" }, // just example; you may embed local font
    // { src: '...', fontWeight: 'bold' } etc.
  ],
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 10,
    padding: 30,
    backgroundColor: "#ffffff",
    color: "#2c2c2c",
    paddingBottom: 75,
    // marginBottom: 20,
  },

  // Compact Header Design
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 20,
    paddingBottom: 15,
    borderBottomWidth: 3,
    borderBottomColor: "#2c3e50",
    borderBottomStyle: "solid",
  },

  headerLeft: {
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 12,
  },

  logoContainer: {
    width: 60,
    height: 60,
    borderRadius: 4,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderStyle: "solid",
  },

  logo: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  hotelInfo: {
    flex: 1,
  },

  hotelName: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: 4,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },

  hotelContact: {
    fontSize: 8,
    color: "#555",
    lineHeight: 1.5,
    marginBottom: 1,
  },

  headerRight: {
    width: 180,
    alignItems: "flex-end",
  },

  invoiceTitle: {
    fontSize: 22,
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: 8,
    letterSpacing: 1,
  },

  invoiceBox: {
    backgroundColor: "#2c3e50",
    padding: 8,
    borderRadius: 3,
    width: "100%",
  },

  invoiceLabel: {
    fontSize: 7,
    color: "#bdc3c7",
    marginBottom: 2,
    textTransform: "uppercase",
  },

  invoiceValue: {
    fontSize: 10,
    color: "#fff",
    fontWeight: "bold",
  },

  // Guest and Stay Info in compact grid
  infoGrid: {
    marginBottom: 20,
  },

  infoRow: {
    flexDirection: "row",
    gap: 15,
  },

  infoBox: {
    flex: 1,
    backgroundColor: "#f8f9fa",
    padding: 12,
    borderLeftWidth: 3,
    borderLeftColor: "#3498db",
    borderLeftStyle: "solid",
    marginBottom: 12,
  },

  infoTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: 8,
    textTransform: "uppercase",
    letterSpacing: 0.3,
  },

  infoDetailRow: {
    flexDirection: "row",
    marginBottom: 4,
  },

  infoLabel: {
    fontSize: 8,
    color: "#7f8c8d",
    width: "35%",
  },

  infoValue: {
    fontSize: 8,
    color: "#2c3e50",
    width: "65%",
    fontWeight: "bold",
  },

  // Charges Table - Compact Design
  table: {
    marginTop: 15,
    marginBottom: 20,
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#34495e",
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
  },

  tableHeaderText: {
    color: "#ecf0f1",
    fontSize: 9,
    fontWeight: "bold",
    textTransform: "uppercase",
  },

  colDate: { width: "12%" },
  colDesc: { width: "53%" },
  colRoom: { width: "15%" },
  colAmount: { width: "20%", textAlign: "right" },

  tableRow: {
    flexDirection: "row",
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#ecf0f1",
    borderBottomStyle: "solid",
  },

  tableRowAlt: {
    backgroundColor: "#f8f9fa",
  },

  tableCell: {
    fontSize: 8,
    color: "#2c3e50",
  },

  tableCellBold: {
    fontWeight: "bold",
  },

  // Summary Section - Compact
  summarySection: {
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "flex-end",
  },

  summaryBox: {
    width: "45%",
    borderTopWidth: 2,
    borderTopColor: "#34495e",
    borderTopStyle: "solid",
    paddingTop: 10,
  },

  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 5,
    paddingHorizontal: 12,
  },

  summaryLabel: {
    fontSize: 9,
    color: "#7f8c8d",
  },

  summaryValue: {
    fontSize: 9,
    color: "#2c3e50",
    fontWeight: "bold",
  },

  summaryTotal: {
    backgroundColor: "#2c3e50",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginTop: 5,
    borderRadius: 3,
  },

  summaryTotalLabel: {
    fontSize: 11,
    color: "#ecf0f1",
    fontWeight: "bold",
    textTransform: "uppercase",
  },

  summaryTotalValue: {
    fontSize: 12,
    color: "#3498db",
    fontWeight: "bold",
  },

  summaryDivider: {
    height: 1,
    backgroundColor: "#ccc",
    marginVertical: 6,
  },
  // // Bank Details Section
  // bankSection: {
  //   marginTop: 25,
  //   padding: 12,
  //   backgroundColor: "#f8f9fa",
  //   borderLeftWidth: 3,
  //   borderLeftColor: "#27ae60",
  //   borderLeftStyle: "solid",
  // },

  // bankTitle: {
  //   fontSize: 9,
  //   fontWeight: "bold",
  //   color: "#2c3e50",
  //   marginBottom: 8,
  //   textTransform: "uppercase",
  // },

  // bankDetailsGrid: {
  //   flexDirection: "row",
  //   flexWrap: "wrap",
  //   gap: 8,
  // },

  // bankDetailItem: {
  //   width: "48%",
  //   flexDirection: "row",
  //   marginBottom: 4,
  // },

  // bankLabel: {
  //   fontSize: 8,
  //   color: "#7f8c8d",
  //   width: "45%",
  // },

  // bankValue: {
  //   fontSize: 8,
  //   color: "#2c3e50",
  //   fontWeight: "bold",
  //   width: "55%",
  // },

  // Compact Footer
  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 10,
    borderTopWidth: 2,
    borderTopColor: "#34495e",
    borderTopStyle: "solid",
  },

  footerLeft: {
    flex: 1,
  },

  footerText: {
    fontSize: 8,
    color: "#7f8c8d",
    marginBottom: 2,
  },

  footerBold: {
    fontSize: 9,
    color: "#2c3e50",
    fontWeight: "bold",
  },

  footerRight: {
    alignItems: "flex-end",
  },

  footerThankYou: {
    fontSize: 9,
    color: "#3498db",
    fontWeight: "bold",
    fontStyle: "italic",
  },
});

const formatDate = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatDateOnly = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const InvoicePDF = ({ data }) => {
  if (!data || !data.customer || !data.hotelDetails) {
    return (
      <Document>
        <Page>
          <Text>No data available</Text>
        </Page>
      </Document>
    );
  }

  const hotel = data.hotelDetails;
  const customer = data.customer;
  const billTo = data?.bill_to || {};
  // const bank = hotel.bank_details || {};

  // Filter out tax rows from charges and group with their base charges
  const displayCharges = data.room_charges;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Compact Header with Logo */}
        <View style={styles.header} fixed>
          <View style={styles.headerLeft}>
            {/* {hotel.logo && (
              <View style={styles.logoContainer}>
                <Image src={hotel?.logo} style={styles.logo} />
              </View>
            )} */}
            {/* <Image src="https://static.rfstat.com/renderforest/images/v2/logo-homepage/logo-3-3.png"  style={styles.logo}/> */}
            <View style={styles.hotelInfo}>
              <Text style={styles.hotelName}>{hotel.name || "Hotel Name"}</Text>
              {hotel.address && (
                <Text style={styles.hotelContact}>{hotel.address}</Text>
              )}
              {(hotel.mobile || hotel.phone) && (
                <Text style={styles.hotelContact}>
                  Ph: {hotel.mobile || hotel.phone}
                </Text>
              )}
              {hotel.email && (
                <Text style={styles.hotelContact}>Email: {hotel.email}</Text>
              )}
              {hotel.gstin && (
                <Text style={styles.hotelContact}>GSTIN: {hotel.gstin}</Text>
              )}
              {hotel.cin && (
                <Text style={styles.hotelContact}>CIN: {hotel.cin}</Text>
              )}
              {hotel.pan && (
                <Text style={styles.hotelContact}>PAN: {hotel.pan}</Text>
              )}
            </View>
          </View>

          <View style={styles.headerRight}>
            <Text style={styles.invoiceTitle}>
              {hotel?.gst_enabled ? "TAX INVOICE" : "INVOICE"}
            </Text>{" "}
            <View style={styles.invoiceBox}>
              <Text style={styles.invoiceLabel}>Invoice No.</Text>
              <Text style={styles.invoiceValue}>{data.inv_no}</Text>
            </View>
            <View
              style={[
                styles.invoiceBox,
                { marginTop: 5, backgroundColor: "#34495e" },
              ]}
            >
              <Text style={styles.invoiceLabel}>Date</Text>
              <Text style={styles.invoiceValue}>
                {formatDate(data.inv_date)}
              </Text>
            </View>
          </View>
        </View>

        {/* Guest & Stay Info Grid */}
        <View style={styles.infoGrid} fixed>
          <View style={styles.infoRow}>
            {/* <View style={styles.infoBox}>
              <Text style={styles.infoTitle}>Guest Details</Text>
              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Name:</Text>
                <Text style={styles.infoValue}>
                  {customer.title} {customer.name}
                </Text>
              </View>
              {customer.mobile && (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>Mobile:</Text>
                  <Text style={styles.infoValue}>{customer.mobile}</Text>
                </View>
              )}
              {customer.email && (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>Email:</Text>
                  <Text style={styles.infoValue}>{customer.email}</Text>
                </View>
              )}
              {customer.address && (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>Address:</Text>
                  <Text style={styles.infoValue}>{customer.address}</Text>
                </View>
              )}
              {customer.gst_no && (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>GST Number:</Text>
                  <Text style={styles.infoValue}>{customer.gst_no}</Text>
                </View>
              )}
            </View> */}
            <View style={styles.infoBox}>
              <Text style={styles.infoTitle}>Guest Details</Text>
              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Name:</Text>
                <Text style={styles.infoValue}>
                  {customer.title} {customer.name}
                </Text>
              </View>
              {customer.mobile && (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>Mobile:</Text>
                  <Text style={styles.infoValue}>{customer.mobile}</Text>
                </View>
              )}
              {customer.email && (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>Email:</Text>
                  <Text style={styles.infoValue}>{customer.email}</Text>
                </View>
              )}
              {customer.address && (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>Address:</Text>
                  <Text style={styles.infoValue}>{customer.address}</Text>
                </View>
              )}
              {customer.gst_no && (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>GST Number:</Text>
                  <Text style={styles.infoValue}>{customer.gst_no}</Text>
                </View>
              )}

              {/* ✅ Bill To Section */}
              {billTo && (
                <>
                  <Text style={[styles.infoTitle, { marginTop: 16 }]}>
                    Bill To
                  </Text>

                  <View style={styles.infoDetailRow}>
                    <Text style={styles.infoLabel}>Type:</Text>
                    <Text style={styles.infoValue}>{billTo.type}</Text>
                  </View>

                  <View style={styles.infoDetailRow}>
                    <Text style={styles.infoLabel}>Name:</Text>
                    <Text style={styles.infoValue}>{billTo.name}</Text>
                  </View>

                  {billTo.email && (
                    <View style={styles.infoDetailRow}>
                      <Text style={styles.infoLabel}>Email:</Text>
                      <Text style={styles.infoValue}>{billTo.email}</Text>
                    </View>
                  )}

                  {billTo.mobile && (
                    <View style={styles.infoDetailRow}>
                      <Text style={styles.infoLabel}>Mobile:</Text>
                      <Text style={styles.infoValue}>{billTo.mobile}</Text>
                    </View>
                  )}

                  {billTo.address && (
                    <View style={styles.infoDetailRow}>
                      <Text style={styles.infoLabel}>Address:</Text>
                      <Text style={styles.infoValue}>{billTo.address}</Text>
                    </View>
                  )}

                  {billTo.gst_number && (
                    <View style={styles.infoDetailRow}>
                      <Text style={styles.infoLabel}>GST Number:</Text>
                      <Text style={styles.infoValue}>{billTo.gst_number}</Text>
                    </View>
                  )}
                </>
              )}
            </View>

            {/* <View style={[styles.infoBox, { borderLeftColor: "#e74c3c" }]}>
              <Text style={styles.infoTitle}>Stay Information</Text>
              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Booking ID:</Text>
                <Text style={styles.infoValue}>{data.booking_id}</Text>
              </View>
              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Check-in:</Text>
                <Text style={styles.infoValue}>{formatDate(data.checkin_date)}</Text>
              </View>
              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Check-out:</Text>
                <Text style={styles.infoValue}>{formatDate(data.checkout_date)}</Text>
              </View>
              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Status:</Text>
                <Text style={styles.infoValue}>
                  {data.pmt_status?.toUpperCase() || "UNPAID"}
                </Text>
              </View>
            </View> */}
            <View style={[styles.infoBox, { borderLeftColor: "#e74c3c" }]}>
              <Text style={styles.infoTitle}>Booking Details</Text>

              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Check-in:</Text>
                <Text style={styles.infoValue}>
                  {formatDate(data.checkin_date)}
                </Text>
              </View>

              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Check-out:</Text>
                <Text style={styles.infoValue}>
                  {formatDate(data.checkout_date)}
                </Text>
              </View>

              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Booking ID:</Text>
                <Text style={styles.infoValue}>{data.booking_id || "N/A"}</Text>
              </View>

              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Booking From:</Text>
                <Text style={styles.infoValue}>{data.from || "N/A"}</Text>
              </View>

              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Invoice No:</Text>
                <Text style={styles.infoValue}>{data.inv_no || "N/A"}</Text>
              </View>

              {data.paid_amount > 0 && (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>Paid Amount:</Text>
                  <Text style={styles.infoValue}>
                    {(data.paid_amount || 0).toFixed(2)}
                  </Text>
                </View>
              )}

              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Payment Status:</Text>
                <Text style={styles.infoValue}>
                  {(data.pmt_status || "unpaid").toUpperCase()}
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* Charges Table */}
        <View
          style={styles.table}
          //  wrap={false}
        >
          <View style={styles.tableHeader} fixed>
            <Text style={[styles.tableHeaderText, styles.colDate]}>Date</Text>
            <Text style={[styles.tableHeaderText, styles.colDesc]}>
              Description
            </Text>
            <Text style={[styles.tableHeaderText, styles.colRoom]}>#SAC</Text>
            <Text style={[styles.tableHeaderText, styles.colAmount]}>
              Amount
            </Text>
          </View>

          {displayCharges.map((item, idx) => (
            <View
              key={idx}
              style={[
                styles.tableRow,
                idx % 2 === 1 ? styles.tableRowAlt : null,
              ]}
            >
              <Text style={[styles.tableCell, styles.colDate]}>
                {formatDateOnly(item.date)}
              </Text>
              <Text style={[styles.tableCell, styles.colDesc]}>
                {item.particulars}
              </Text>
              <Text style={[styles.tableCell, styles.colRoom]}>
                {item.sac_code || "-"}
              </Text>
              <Text
                style={[
                  styles.tableCell,
                  styles.colAmount,
                  styles.tableCellBold,
                ]}
              >
                {item.amount ? `  ${Number(item.amount).toFixed(2)}` : "-"}
              </Text>
            </View>
          ))}
        </View>

        {/* Summary */}
        {/* <View style={styles.summarySection} wrap={false}>
          <View style={styles.summaryBox}>
            <View style={styles.summaryRow}>
              <Text style={styles.summaryLabel}>Subtotal</Text>
              <Text style={styles.summaryValue}>
                  {Number(data.amount || 0).toFixed(2)}
              </Text>
            </View>
            <View style={styles.summaryRow}>
              <Text style={styles.summaryLabel}>SGST (2.5%)</Text>
              <Text style={styles.summaryValue}>
                  {Number(data.sgst || 0).toFixed(2)}
              </Text>
            </View>
            <View style={styles.summaryRow}>
              <Text style={styles.summaryLabel}>CGST (2.5%)</Text>
              <Text style={styles.summaryValue}>
                  {Number(data.cgst || 0).toFixed(2)}
              </Text>
            </View>
            <View style={styles.summaryTotal}>
              <Text style={styles.summaryTotalLabel}>Total Amount</Text>
              <Text style={styles.summaryTotalValue}>
                  {Number(data.total || 0).toFixed(2)}
              </Text>
            </View>
          </View>
        </View> */}

        <View style={styles.summarySection} wrap={false}>
          <View style={styles.summaryBox}>
            {/* Subtotal */}
            <View style={styles.summaryRow}>
              <Text style={styles.summaryLabel}>Subtotal</Text>
              <Text style={styles.summaryValue}>
                {Number(data.amount || 0).toFixed(2)}
              </Text>
            </View>

            {hotel?.gst_enabled && (
              <>
                {/* SGST */}
                <View style={styles.summaryRow}>
                  <Text style={styles.summaryLabel}>SGST</Text>
                  <Text style={styles.summaryValue}>
                    {Number(data.sgst || 0).toFixed(2)}
                  </Text>
                </View>

                {/* CGST */}
                <View style={styles.summaryRow}>
                  <Text style={styles.summaryLabel}>CGST</Text>
                  <Text style={styles.summaryValue}>
                    {Number(data.cgst || 0).toFixed(2)}
                  </Text>
                </View>
              </>
            )}

            {/* Divider */}
            <View style={styles.summaryDivider} />

            {/* Grand Total */}
            <View style={styles.summaryTotal}>
              <Text style={styles.summaryTotalLabel}>Grand Total</Text>
              <Text style={styles.summaryTotalValue}>
                {Number(data.total || 0).toFixed(2)}
              </Text>
            </View>

            {/* Advance Paid and Balance Due if applicable */}
            {Number(data.paid_amount) > 0 && (
              <>
                {/* Advance Paid */}
                <View style={styles.summaryRow}>
                  <Text style={styles.summaryLabel}>Advance Paid</Text>
                  <Text style={styles.summaryValue}>
                    - {Number(data.paid_amount).toFixed(2)}
                  </Text>
                </View>

                {/* Divider */}
                <View style={styles.summaryDivider} />

                {/* Balance Due */}
                <View style={styles.summaryTotal}>
                  <Text style={styles.summaryTotalLabel}>Balance Due</Text>
                  <Text style={styles.summaryTotalValue}>
                    {(
                      Number(data.total || 0) - Number(data.paid_amount)
                    ).toFixed(2)}
                  </Text>
                </View>
              </>
            )}
          </View>
        </View>

        {/* Compact Footer */}
        <View style={styles.footer} fixed>
          <View style={styles.footerLeft}>
            <Text style={styles.footerText}>
              Generated on: {new Date().toLocaleDateString("en-IN")}
            </Text>
            <Text style={styles.footerBold}>
              For any queries, contact:{" "}
              {hotel.mobile || hotel.phone || hotel.email}
            </Text>
          </View>
          <View style={styles.footerRight}>
            <Text style={styles.footerThankYou}>Thank You for Your Stay!</Text>
            <Text style={[styles.footerText, { marginTop: 3 }]}>
              {hotel.name}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};
export default InvoicePDF;
